<div class="main-container">
  <mat-toolbar color="primary" class="topbar relative" style="padding-left: 0px;">
    <div class="navbar-header">
      <a class="appName" href="/">
        <img src="../../../assets/img/Hub_Header.png">
      </a>
    </div>
    <button mat-icon-button type="button" *ngIf="showSideNav" (click)="sidebarToggle()" value="sidebarclosed">
      <mat-icon class="header-icon">{{icon}}</mat-icon>
    </button>
    <span class="route">{{url?.title | translate}}</span>
    <span fxFlex></span>
    <lib-app-bar [urlWikisite]="urlWikisite" [isHelpEnabled]="isHelpEnabled" [isNotificationEnabled]="isNotificationEnabled" [langCodesException]="['pt']"></lib-app-bar>
  </mat-toolbar>
  <mat-sidenav-container class="sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
    <mat-sidenav #snav id="snav" class="pl-xs" *ngIf="showSideNav" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0"
      [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches" (open)="sidebarOpened = true"
      (close)="sidebarOpened = false">
      <lib-menu-side-nav class="app-sidebar" [menuItems]="menuItems"></lib-menu-side-nav>
    </mat-sidenav>
    <mat-sidenav-content class="page-wrapper">
      <div class="page-content">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<div class='environnement'>
  <span  *ngIf='envName' class="badge" >{{envName}}</span>
</div>
<div class='version'>
  <span  *ngIf='buildVersion' class="badge" style="background-color:royalblue;" >v{{buildVersion}}</span>
</div>
